import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { Currency, ListResponse } from '@/types';
import { Pagination } from '@/components';
import { EditFlat, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteCurrency, UpdateCurrency } from '../components';

export interface CurrencyListProps {
  list?: ListResponse<Currency>;
  page: number;
  onChangePage(page: number): void;
}

const CurrenciesTable: React.FC<CurrencyListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentCurrency, setCurrentCurrency] = useState<Currency | null>(null);

  function openUpdateModal(currency: Currency) {
    setCurrentCurrency(currency);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(currency: Currency) {
    setCurrentCurrency(currency);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Код</TableCell>
                <TableCell />
                <TableCell>Полное название</TableCell>
                <TableCell>Название</TableCell>
                <TableCell>Курс</TableCell>
                <TableCell>multiplicity</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((currency) => {
                const { code, full_name, short_name, course, multiplicity, id } = currency;

                return (
                  <TableRow key={id}>
                    <TableCell>{code}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(currency)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(currency)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>

                    <TableCell>{full_name ?? '—'}</TableCell>
                    <TableCell>{short_name ?? '—'}</TableCell>
                    <TableCell>{course ?? '—'}</TableCell>
                    <TableCell>{multiplicity ?? '—'}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateCurrency
        currency={currentCurrency!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteCurrency
        currency={currentCurrency!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default CurrenciesTable;
